/** Refcount of in-flight blob uploads; warns on tab close while > 0. */

let inFlight = 0;
let bound = false;

function onBeforeUnload(event: BeforeUnloadEvent): void {
  if (inFlight <= 0) {
    return;
  }
  event.preventDefault();
  event.returnValue = '';
}

function ensureBound(): void {
  if (bound || typeof window === 'undefined') {
    return;
  }
  window.addEventListener('beforeunload', onBeforeUnload);
  bound = true;
}

export function beginUploadGuard(): void {
  ensureBound();
  inFlight += 1;
}

export function endUploadGuard(): void {
  inFlight = Math.max(0, inFlight - 1);
}

/** Test helper. */
export function getInFlightUploadCount(): number {
  return inFlight;
}

/** Test helper. */
export function resetUploadGuardForTests(): void {
  inFlight = 0;
}
